function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#login_google_svg__clip0_295_4065)"
}, React.createElement("path", {
  d: "M5.66 5.68A16.826 16.826 0 0115.81.425a17.298 17.298 0 017.787.546 17.543 17.543 0 016.793 3.922c.77.683.76.694.07 1.408-1.35 1.366-2.7 2.723-4 4.08-.27.295-.43.336-.77 0a10.591 10.591 0 00-7.387-2.867A10.604 10.604 0 0011 10.595a1.765 1.765 0 01-.24.174l-5.1-5.09z",
  fill: "#EA4235"
}), React.createElement("path", {
  d: "M5.66 5.678l5.08 5.1a11.538 11.538 0 00-3 6.344 11.123 11.123 0 00.376 4.75 10.97 10.97 0 002.324 4.134l.33.408-5 5.172a17.214 17.214 0 01-4.94-9.18 18.393 18.393 0 01.237-8.69 18.14 18.14 0 014.193-7.57c.125-.163.259-.32.4-.468z",
  fill: "#FABD05"
}), React.createElement("path", {
  d: "M5.73 31.577l5-5.172a11.166 11.166 0 006.13 3.06 10.49 10.49 0 004.737-.369 10.643 10.643 0 004.113-2.426l.34-.285c1.68 1.724 3.35 3.458 5 5.181-3.252 3.3-7.615 5.21-12.2 5.338-4.585.13-9.045-1.532-12.47-4.644-.21-.194-.38-.449-.65-.683z",
  fill: "#35AA51"
}), React.createElement("path", {
  d: "M31.08 31.587c-1.67-1.724-3.34-3.458-5-5.182a12.854 12.854 0 002.22-3.335c.34-.806.34-.806-.49-.806h-5.17c-.5 0-.63-.143-.63-.643v-6.12c0-.449.09-.622.58-.622h13c.4 0 .55.122.61.54a18.562 18.562 0 01-.253 7.513A18.362 18.362 0 0132.74 29.7a12.423 12.423 0 01-1.66 1.887z",
  fill: "#4186F6"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "login_google_svg__clip0_295_4065"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h39v39H0z"
})));

var SvgLoginGoogle = function SvgLoginGoogle(props) {
  return React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 -11 60 60",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgLoginGoogle;